import { useQuery } from "@tanstack/react-query";

import { api } from "./client";
import { queryKeys } from "./keys";
import type { AuditLogEntry, ListResponse } from "./types";

const base = "/v1/audit-log";

export interface AuditLogForEntityParams {
  entityType: string;
  entityID: string;
  since?: string;
  limit?: number;
}

export function useAuditLogForEntity(params: AuditLogForEntityParams | null) {
  return useQuery({
    queryKey: params
      ? queryKeys.auditLog.forEntity(params.entityType, params.entityID)
      : queryKeys.auditLog.forEntity("", ""),
    queryFn: ({ signal }) =>
      api.get<ListResponse<AuditLogEntry>>(
        base,
        {
          entity_type: params?.entityType,
          entity_id: params?.entityID,
          since: params?.since,
          limit: params?.limit,
        },
        signal,
      ),
    enabled: !!params?.entityType && !!params?.entityID,
  });
}

export interface AuditLogTenantParams {
  since?: string;
  limit?: number;
  offset?: number;
}

export function useTenantAuditLog(params: AuditLogTenantParams = {}) {
  return useQuery({
    queryKey: queryKeys.auditLog.tenant,
    queryFn: ({ signal }) =>
      api.get<ListResponse<AuditLogEntry>>(
        base,
        {
          since: params.since,
          limit: params.limit,
          offset: params.offset,
        },
        signal,
      ),
  });
}
